import {AfterViewInit, Component, OnInit} from '@angular/core';

const breakpoint = window.matchMedia( '(min-width: 980.98px)' );
const CHAT_SCROLL_TIME = 500;
const MENU_H = 70;

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.css']
})
export class SurveyComponent implements OnInit,AfterViewInit {

  score = {
    Q1: 0,
    Q2: 0,
    Q3: 0,
    Q4: 0,
    Q5: 0,
    Q6: 0,
    Q7: 0,
    Q8: 0,
  };
  Q7:number[] = []; // checkbox

  constructor() { }

  ngOnInit(): void {
    // let s = this.score;
    // setInterval(function () {
    //   console.log('score', s);
    // },1000);
  }

  ngAfterViewInit(): void {
    let survey_scroll_top_sum = 0;

    //footer anchor, to top/ to bottom
    $('[data-id="idAnchorTop"]').on('click', function () {
      var scroll_top =  $('.jsWelcomeChat').offset()!.top - MENU_H;
      $('.jsChatMainWrapper').animate({ scrollTop: scroll_top }, CHAT_SCROLL_TIME);
    });
    $('[data-id="idAnchorBottom"]').on('click', function () {
      var scroll_bottom =  $('.jsWelcomeChat').height() ;
      $('.jsChatMainWrapper').animate({ scrollTop: scroll_bottom }, CHAT_SCROLL_TIME);
    });

    //------ 完整版
    //progress bar toggle - PC
    $('[data-toggle = "idProgressBarPC"]').on('click', function () {
      if ($('[data-target ="idProgressBarPC"]').hasClass('close')) {
        $('[data-target ="idProgressBarPC"]').removeClass('close');
      } else {
        $('[data-target ="idProgressBarPC"]').addClass('close');
      }
    });
    //progress bar toggle - Mobile
    $('[data-toggle = "idProgressBarMo"]').on('click', function () {
      if ($('[data-target ="idProgressBarMo"]').hasClass('close')) {
        $('[data-target ="idProgressBarMo"]').removeClass('close').fadeOut(0).fadeIn(100);
      } else {
        $('[data-target ="idProgressBarMo"]').fadeOut(100, function () {
          $(this).addClass('close'); //or any other class
        });
      }
    });
    //------ 完整版
    //風險問卷
    surveyUnlockFirstQuestions();
    $('.ra-survey-item.is-hidden').on('click', function (e) {
      e.stopPropagation();
      //出現解鎖說明: 請先作答上方題目
      if( $(this).children('.ra-survey-lock-hint').hasClass('is-hidden') ){
        $(this).children('.ra-survey-lock-hint').removeClass('is-hidden');
      }
      console.log('aaaa');
      // $('.jsChatMainWrapper').animate({
      //   scrollTop: survey_scroll_top_sum
      // }, CHAT_SCROLL_TIME);
    });
    $('.ra-survey-radio').on('click', function (e) {
      e.stopPropagation();
      var survey_item = $(this).closest('.ra-survey-item');
      var survey_item_next = survey_item.next();
      //檢查與解鎖下一個survey item
      if( !survey_item.hasClass('is-hidden') && survey_item_next.hasClass('is-hidden') ){
        survey_item_next.removeClass('is-hidden').addClass('animate-it');
        survey_item_next.find('.ra-survey-radio').prop("disabled", false); //可以點選答案了

        //如果是最後一題，則出現結果區塊
        if (survey_item_next.attr("data-id") == "DONE" && $('.ra-survey-rst-container').hasClass('is-hidden')) {
          $('.ra-survey-rst-container').removeClass('is-hidden');

          //解鎖scrollbar
          $('.jsChatMainWrapper').removeClass('ra-STOP-SCROLLING');

          if (breakpoint.matches === true) {//PC mode
            console.log('LAST ORDER pc~');
            survey_scroll_top_sum += - MENU_H -55;
          }else{
            console.log('LAST ORDER mo~');
            survey_scroll_top_sum += survey_item.height()!;
          }
        }else{
          //非最後一題
          survey_scroll_top_sum += survey_item_next.offset()!.top - MENU_H;
        }
        $('.jsChatMainWrapper').animate({
          scrollTop: survey_scroll_top_sum
        }, CHAT_SCROLL_TIME);
        console.log('survey_item_next.top: ' + survey_item_next.offset()!.top);
        console.log('scrollTop: ' + survey_scroll_top_sum);
      }else{

      }
    });

    function surveyUnlockFirstQuestions(){
      $('.ra-survey-item').first().removeClass('is-hidden');
      $('.ra-survey-item').first().find('.ra-survey-radio').prop("disabled", false);
    }

  }

  get totalScore(): number {
    return this.score.Q1
        + this.score.Q2
        + this.score.Q3
        + this.score.Q4
        + this.score.Q5
        + this.score.Q6
        + this.score.Q7
        + this.score.Q8
    ;
  }

  get resultClass(): string {
    let s = this.totalScore;
    if(s<=25 || this.score.Q2===0) {
      // Q2=0 一律為保守型
      return 'surv-rst-conserv';
    }
    else if(s>=26 && s<=54) {
      return 'surv-rst-steady';
    }
    else if(s>=55) {
      return 'surv-rst-active';
    }
    else {
      return 'unknown';
    }
  }

  toggleQ7($event:any, val:number): void {
    // console.log('toggleQ7', $event.currentTarget.checked);
    if($event.currentTarget.checked) {
      this.Q7.push(val);
    } else {
      this.Q7 = this.Q7.filter(x=>x!==val); // 移除
    }
    // console.log(this.Q7);
    this.score.Q7 = this.Q7.reduce((c,v) => {
      return Math.max(c,v);
    }, 0);
    // console.log('Q7 Max', this.score.Q7);
  }
}
